import { Navigate } from "react-router-dom";
import './rsvp.css'
import { useState } from "react";

function RSVP() {

    const [submitted, setSubmitted] = useState(false)
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    function RSVPModal() {

        async function submitRSVP(formData: any) {

            const plaintextMessage = `New RSVP:\n
                Name: ${formData.get("name")}\n
                Email: ${formData.get("email")}\n
                Phone number: ${formData.get("phoneNumber")}\n
                Number of Guests: ${formData.get("numberOfGuests")} guests
                Number of Kids: ${formData.get("numberOfKids")}
                Dietary Restrictions: ${formData.get("dietaryRestrictions")}
                Notes: ${formData.get("anythingElse")}`
            const htmlMessage = `<p>Name: ${formData.get("name")}</p>
                <p>Email: ${formData.get("email")}</p>
                <p>Phone number: ${formData.get("phoneNumber")}</p>
                <p>Number of Guests: ${formData.get("numberOfGuests")} guests</p>
                <p>Number of Kids: ${formData.get("numberOfKids")}</p>
                <p>Dietary Restrictions: ${formData.get("dietaryRestrictions")}</p>
                <p>Notes: ${formData.get("anythingElse")}</p>`

            const body = JSON.stringify({
                "Messages": [{
                    "From": { "Email": "bgavsite@gmail.com", "Name": "Wedding Website" },
                    "To": [{ "Email": "nickandkruthi@gmail.com", "Name": "Nick and Kruthi" }],
                    "Cc": [{ "Email": "bhargavbannigeri+wedding@gmail.com", "Name": "Bhargav Annigeri" },],
                    "Subject": `New Wedding RSVP: ${formData.get("name")}`,
                    "TextPart": plaintextMessage,
                    "HtmlPart": htmlMessage
                }]
            });

            let options = {
                method: "POST",
                body: body
            }

            setLoading(true)

            fetch("/send", options)
                .then((resp) => {
                    setLoading(false)
                    if (resp.status === 200) {
                        setSubmitted(true)
                    } else {
                        setError(true)
                    }
                })
        }

        function formatNumber(input: string) {
            input = input.replace(/\D/g, '').substring(0, 10);

            var size = input.length
            if (size > 0) {
                input = "(" + input
            }

            if (size > 3) {
                input = input.slice(0, 4) + ") " + input.slice(4);
            }

            if (size > 6) {
                input = input.slice(0, 9) + "-" + input.slice(9);
            }

            return input;
        }

        if (error) {
            return (
                <div className="RSVP-modal">
                    <div className="form">
                        <p className="error-text">
                            There was an issue sending your RSVP! Please try again or <a href="mailto:bannigeri17@gmail.com" className="mailto">email Bhargav Annigeri to report the issue</a>.
                        </p>
                    </div>
                </div>
            )
        }

        if (submitted) {
            return (
                <div className="RSVP-modal">
                    <div className="form">
                        <p className="submitted-text">
                            Your RSVP has been submitted. Thank you!
                        </p>
                    </div>
                </div>
            )
        }

        if (loading) {
            return (
                <progress />
            )
        }

        return (
            <>
                <div className="RSVP-modal">
                    <form className="form" action={submitRSVP}>

                        {/* NAME */}
                        <div className="input-row">
                            <label className="form-label">Name: </label>
                            <input className="form-input" required name="name"></input>
                        </div>


                        {/* EMAIL */}
                        <div className="input-row">
                            <label className="form-label">Email: </label>
                            <input className="form-input" required name="email"></input>
                        </div>

                        {/* PHONE NUMBER */}
                        <div className="input-row">
                            <label className="form-label">Phone number:</label>
                            <input className="form-input" type="tel" required name="phoneNumber" pattern="\([0-9]{3}\) [0-9]{3}-[0-9]{4}"
                                onInput={(e) => {
                                    if (e.currentTarget.value != null) {
                                        e.currentTarget.value = (formatNumber(e.currentTarget.value));
                                    }
                                }}
                                title="10-digit phone number"
                            ></input>
                        </div>

                        {/* NUMBER OF GUESTS */}
                        <div className="input-row">
                            <label className="form-label">Number of guests:</label>
                            <select name="numberOfGuests">
                                <option value={1}>1</option>
                                <option value={2}>2</option>
                                <option value={3}>3</option>
                                <option value={4}>4</option>
                                <option value={5}>5</option>
                                <option value={6}>6</option>
                            </select>
                        </div>

                        <hr />

                        {/* NUMBER OF KIDS */}
                        <div className="input-area">
                            <label className="form-label">If any of your guests are kids, how old are they?</label>
                            <textarea className="form-area" name="numberOfKids"></textarea>
                        </div>

                        {/* DIETARY RESTRICTIONS */}
                        <div className="input-area">
                            <label className="form-label">Any dietary restrictions in your party?</label>
                            <textarea className="form-area" name="dietaryRestrictions"></textarea>
                        </div>

                        {/* ANYTHING ELSE */}
                        <div className="input-area">
                            <label className="form-label">Anything else we should know?</label>
                            <textarea className="form-area" name="anythingElse"></textarea>
                        </div>

                        <input className="submit-button" type="submit" value="Submit"></input>
                    </form>
                </div>
            </>
        )
    }

    if (window.sessionStorage.getItem("loggedIn") !== "TRUE") {
        return <Navigate to="/" />
    }
    return (
        <div style={{ "width": "100%", "justifyItems": "center" }}>
            <RSVPModal />
        </div>
    )
}

export default RSVP;